import React from "react";
import { ChecklistView } from "../../../quality/checklists/checklist";

/**
 * HSE/KS Checklist View - Sjekkliste detaljer (ISO 9001:2015 kap. 8.5)
 */
export const HseKsChecklistView = () => {
  return <ChecklistView />;
};
